import React, { useEffect, useRef, useState } from 'react'
import { Group } from '@visx/group'
import { hierarchy, Tree } from '@visx/hierarchy'
import { LinearGradient } from '@visx/gradient'
import { Zoom } from '@visx/zoom'
import { localPoint } from '@visx/event'
import { RectClipPath } from '@visx/clip-path'
import getLinkComponent from './getLinkComponent'
import LinkControls from './LinkControls'
import Avatar0 from './img/item__img.png'
import Avatar1 from './img/avatar1.png'
import UserInfoTab from './userInfoTab'
import SectionModal from '../modals/sectionModal'
import { Button } from 'antd'
import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import EmployeeModal from '../modals/employesModal'

interface TreeNode {
  name: string
  title?: string
  photo?: any
  id: number
  subs?: string
  level?: number
  repost?: any
  size?: number
  isExpanded?: boolean
  children?: TreeNode[]
  users?: TreeNode[]
  count?: number
}

const defaultMargin = { top: 0, left: 50, right: -50, bottom: 0 }

export type LinkTypesProps = {
  width: number
  height: number
  margin?: { top: number; right: number; bottom: number; left: number }
}
export const StructureGraph = ({ margin = defaultMargin }) => {

  const [layout, setLayout] = useState<string>('cartesian')
  const [modalDepOpen, setModalDepOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [orientation, setOrientation] = useState<string>('vertical')
  const [linkType, setLinkType] = useState<string>('step')
  const [item, setItem] = useState<string>('')
  const [stepPercent, setStepPercent] = useState<number>(1)


  const [structure, setStructure] = useState<any>({})

  let type = localStorage.getItem("usertype")

  const closeModal = (value: TreeNode) => {
    setModalDepOpen(false)
    setModalOpen(false)
  }

  useEffect(() => {
    let arr = {
      name: 'main',
      id: 0,
      count: 0,
      children: [
        {
          id: 1,
          title: 'Руководство',
          name: 'Иванов Семён Петрович',
          photo: { Avatar1 },
          subs: 'Генеральный директор',
          size: 16,
          users: [
            {
              id: 2,
              repost: 1,
              name: 'Мельник Софья Николаевна',
              photo: "https://img.freepik.com/free-photo/lifestyle-business-people-holding-laptop-computer-office-desk_1150-10180.jpg?t=st=1744101804~exp=1744105404~hmac=379649786aa0e1e976167ecf75009392227faae635cef4d8047a1d1170b43fa2&w=1380",
              subs: 'Помощник директора',
              size: 16,
              children: [],
              level: 1,
            },
          ],
          children: [
            {
              id: 5,
              title: 'Отдел Маркетинга',
              repost: 2,
              name: 'Киселев Даниил',
              photo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQlAdxI21DMWbHvWDHQQEL4oqw80_oIpp5i0A&s",
              subs: 'Руководитель Отдела Маркетинга',
              size: 16,
              users: [
                {
                  id: 9,
                  repost: 2,
                  name: 'Пирожниченко Леонид',
                  photo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQlAdxI21DMWbHvWDHQQEL4oqw80_oIpp5i0A&s",
                  subs: 'Маркетолог',
                  size: 16,
                  children: [],
                  level: 2,
                },
                {
                  id: 10,
                  repost: 2,
                  name: 'Кравченко Евгений',
                  photo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQlAdxI21DMWbHvWDHQQEL4oqw80_oIpp5i0A&s",
                  subs: 'Помощник маркетолога',
                  size: 16,
                  children: [],
                  level: 2,
                },
                {
                  id: 11,
                  repost: 2,
                  name: 'Петров Василий',
                  photo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQlAdxI21DMWbHvWDHQQEL4oqw80_oIpp5i0A&s",
                  subs: 'SMM менеджер',
                  size: 16,
                  children: [],
                  level: 2,
                },
                {
                  id: 12,
                  repost: 2,
                  name: 'Иван Смирнов',
                  photo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQlAdxI21DMWbHvWDHQQEL4oqw80_oIpp5i0A&s",
                  subs: 'SMM менеджер',
                  size: 16,
                  children: [],
                  level: 2,
                },
                {
                  id: 12,
                  repost: 2,
                  name: 'Августинов Петр',
                  photo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQlAdxI21DMWbHvWDHQQEL4oqw80_oIpp5i0A&s",
                  subs: 'SMM менеджер',
                  size: 16,
                  children: [],
                  level: 2,
                },
              ],
              level: 2,
            },
            {
              id: 6,
              title: 'Отдел ИТ',
              repost: 3,
              name: 'Слепаков Семен Семенович',
              photo: { Avatar0 },
              subs: 'Руководитель',
              size: 16,
              users: [
                {
                  id: 9,
                  repost: 2,
                  name: 'Гаврилов Пётр Иванович',
                  photo: { Avatar0 },
                  subs: 'Инженер',
                  size: 16,
                  children: [],
                  level: 2,
                },
                {
                  id: 10,
                  repost: 2,
                  name: 'Петров Артемий Валентинович',
                  photo: { Avatar0 },
                  subs: 'Инженер',
                  size: 16,
                  children: [],
                  level: 2,
                },
              ],
              level: 2,
            },
            {
              id: 7,
              title: 'Бухгалтерия',
              repost: 3,
              name: 'Звездная Екатерина Олеговна',
              photo: { Avatar0 },
              subs: 'Главный бухгалтер',
              size: 16,
              users: [
                {
                  id: 9,
                  repost: 2,
                  name: 'Серова Ирина Олеговна',
                  photo: "https://ascon-profi.ru/kurs-buhgalter-s-nulya/img/buhgalter7-5.jpg",
                  subs: 'Бухгалтер',
                  size: 16,
                  children: [],
                  level: 2,
                },
              ],
              level: 2,
            },
            {
              id: 8,
              title: 'Склад',
              repost: 2,
              name: 'Фролов Дмитрий Николаевич',
              photo: "https://oxrana-truda.ru/backend/uploads/administrativno-texnicheskij-personal/administrativno-texnicheskij-personal.jpg",
              subs: 'Начальник склада',
              size: 16,
              users: [
                {
                  id: 9,
                  repost: 2,
                  name: 'Семенов Иван Николаевич',
                  photo: { Avatar0 },
                  subs: 'Кладовщик',
                  size: 16,
                  children: [],
                  level: 2,
                },
              ],
              level: 2,
            },
          ],
        },
      ],
    }
    setStructure(arr)
  }, [])

  const totalWidth = document.documentElement.clientWidth - 50
  const totalHeight = document.documentElement.clientHeight - 150
  const zoomRef: any = useRef()

  let arrImg: any[] = []

  let innerWidth = totalWidth - margin.left - margin.right
  let innerHeight = totalHeight - margin.top - margin.bottom

  let origin: { x: number; y: number }
  let sizeWidth: number
  let sizeHeight: number

  if (layout === 'polar') {
    origin = {
      x: innerWidth / 2,
      y: innerHeight / 2,
    }
    sizeWidth = 2 * Math.PI
    sizeHeight = Math.min(innerWidth, innerHeight) / 2
  } else {
    if (orientation === 'vertical') {
      origin = { x: 0, y: -innerHeight / 4 }
      sizeWidth = innerWidth
      sizeHeight = innerHeight
    } else {
      origin = { x: -innerWidth / 4, y: 0 }
      sizeWidth = innerHeight
      sizeHeight = innerWidth
    }
  }

  const LinkComponent = getLinkComponent({ layout, linkType, orientation })
  const initialTransform = {
    scaleX: 0.8,
    scaleY: 0.8,
    translateX: 0,
    translateY: 0,
    skewX: 0,
    skewY: 0,
  }

  return totalWidth < 10 ? null : (
    <div className='margin-block'>
      <div className='flex-space'>

        {type == "industry" && (<div className='btn-group'>
          <Button onClick={() => {setModalDepOpen(true); setItem('')}}><PlusOutlined /> Добавить отдел</Button>
          {" "}
          <Button onClick={() => setModalOpen(true)}><PlusOutlined /> Добавить сотрудника организации</Button>
        </div>)}
      </div>
      <LinkControls
        layout={layout}
        orientation={orientation}
        linkType={linkType}
        stepPercent={stepPercent}
        setLayout={setLayout}
        setOrientation={setOrientation}
        setLinkType={setLinkType}
        setStepPercent={setStepPercent}
      />

      <Zoom<SVGSVGElement>
        width={innerWidth}
        height={innerHeight}
        scaleXMin={0.7}
        scaleXMax={5}
        scaleYMin={0.7}
        scaleYMax={5}
        initialTransformMatrix={initialTransform}
      >
        {(zoom) => (
          <div id="invoice" className="relative">
            <div className="zoom controls noPrint">
            <PlusOutlined onClick={() => zoom.scale({ scaleX: 1.2, scaleY: 1.2 })} />
            <MinusOutlined onClick={() => zoom.scale({ scaleX: 0.8, scaleY: 0.8 })} />
            </div>
           {/* <div className="controls noPrint">
              <button
                type="button"
                className="btn btn-zoom"
                onClick={() => zoom.scale({ scaleX: 1.2, scaleY: 1.2 })}
              >
                +
              </button>
              <button
                type="button"
                className="btn btn-zoom btn-bottom"
                onClick={() => zoom.scale({ scaleX: 0.8, scaleY: 0.8 })}
              >
                -
              </button>
            </div>*/}
            <svg
              width={totalWidth}
              height={'500'}
              style={{
                cursor: zoom.isDragging ? 'grabbing' : 'grab',
                touchAction: 'none',
              }}
              ref={zoom.containerRef}
            >
              <RectClipPath
                id="zoom-clip"
                width={totalWidth}
                height={totalHeight}
              />
              <LinearGradient id="links-gradient" from="#fd9b93" to="#fe6e9e" />
              <rect
                width={totalWidth}
                height={totalHeight}
                rx={14}
                fill="none"
                onTouchStart={zoom.dragStart}
                onTouchMove={zoom.dragMove}
                onTouchEnd={zoom.dragEnd}
                onMouseDown={zoom.dragStart}
                onMouseMove={zoom.dragMove}
                onMouseUp={zoom.dragEnd}
                onMouseLeave={() => {
                  if (zoom.isDragging) zoom.dragEnd()
                }}
                onDoubleClick={(event) => {
                  const point = localPoint(event) || { x: 0, y: 0 }
                  zoom.scale({ scaleX: 1.1, scaleY: 1.1, point })
                }}
              />
              <g transform={zoom.toString()}>
                <Group top={margin.top} left={margin.left}>
                  <Tree
                    root={hierarchy(structure, (d) =>
                      d.isExpanded ? null : d.children,
                    )}
                    size={[sizeWidth, sizeHeight]}
                    separation={(a, b) =>
                      (a.parent === b.parent ? 1.2 : 1.5) / a.depth
                    }
                  >
                    {(tree) => (
                      <Group top={origin.y} left={origin.x}>
                        <defs>
                          <linearGradient
                            id="gradient"
                            x1="10%"
                            y1="50%"
                            x2="10%"
                            y2="100%"
                          >
                            <stop offset="0%" stopColor="#00bc9b" />
                            <stop offset="100%" stopColor="#fff" />
                          </linearGradient>
                        </defs>
                        {tree
                          .links()
                          .slice(structure?.children?.length)
                          .map((link, i) => (
                            <LinkComponent
                              key={i}
                              data={link}
                              percent={stepPercent}
                              stroke="#c9c9c9"
                              strokeWidth="2"
                              fill="none"
                            />
                          ))}

                        {tree.descendants().map((node, key) => {
                          const width = 40
                          const height = 20

                          let top: number
                          let left: number
                          if (orientation === 'vertical') {
                            top = node.y
                            left = node.x
                          } else {
                            top = node.x
                            left = node.y
                          }

                          return (
                            <Group top={top} left={left} key={key}>

                              {node.depth !== 0 && (

                                <>
                                  <defs>
                                    <filter
                                      id="ffff1"
                                      x="0"
                                      y="0"
                                      width="150%"
                                      height="150%"
                                    >
                                      <feOffset
                                        result="offOut"
                                        in="SourceGraphic"
                                        dx="1"
                                        dy="1"
                                      />
                                      <feColorMatrix
                                        result="matrixOut"
                                        in="offOut"
                                        type="matrix"
                                        values="0.2 0 0 0 0 0 0.2 0 0 0 0 0 0.2 0 0 0 0 0 0.5 0"
                                      />
                                      <feGaussianBlur
                                        result="blurOut"
                                        in="matrixOut"
                                        stdDeviation="10"
                                      />
                                      <feBlend
                                        in="SourceGraphic"
                                        in2="blurOut"
                                        mode="normal"
                                      />
                                    </filter>
                                  </defs>



                                  <rect
                                    filter="photo(#ffff1)"
                                    height="220px"
                                    width="350px"
                                    y="10"
                                    x="-170"
                                    fill="#fff"
                                    strokeWidth={1}
                                    strokeDasharray={
                                      node.data.children ? '0' : '2,2'
                                    }
                                    strokeOpacity={node.data.children ? 1 : 0.6}
                                  //onClick={() => {
                                  //  addSourceBtnCLickHandler()
                                  //  setStructureItem(node.data.id)
                                  //}}
                                  />
                                  <rect
                                    height="20px"
                                    width="350px"
                                    y="-10"
                                    x="-170"
                                    //fill="#fff"
                                    fill="#4FD1C5"
                                    strokeWidth={2}
                                    strokeDasharray={
                                      node.data.children ? '0' : '2,2'
                                    }
                                    strokeOpacity={node.data.children ? 1 : 0.6}
                                  //rx={node.data.children ? 0 : 10}
                                  />
                                  {type == "industry" && <image
                                    onClick={() => {setModalDepOpen(true); setItem(node.data.title)}}
                                    xlinkHref="/settings.png"
                                    y={-10}
                                    x={150}
                                    width="18px"
                                    height="18px"
                                  />}

                                  <foreignObject
                                    //onClick={addSourceBtnCLickHandler}
                                    className="user-title"
                                    y={-10}
                                    x={-165}
                                    width="350"
                                    height="70"
                                    fontSize={17}
                                    fontFamily="Arial"
                                    textAnchor="middle"
                                    style={{ pointerEvents: 'none' }}
                                    color={
                                      node.depth === 0
                                        ? 'white'
                                        : node.children
                                          ? 'black'
                                          : 'black'
                                    }
                                  >
                                    {node.data.title
                                      ? node.data.title
                                        .toString()
                                        .substring(0, 30)
                                      : ''}
                                    {type == "industry" && <image
                                      //xlinkHref={data?.url[`Avatar${data?.id - 1}`]}
                                      onClick={() => setModalOpen(true)}
                                      xlinkHref="/settings.png"
                                      y={-10}
                                      x={-90}
                                      width="18px"
                                      height="18px"
                                    />}
                                  </foreignObject>

                                  <UserInfoTab data={node.data} position={0} />
                                  <rect
                                    height="0.5px"
                                    width="350px"
                                    y="70"
                                    x="-170"
                                    fill="#000"
                                    strokeWidth={2}
                                    strokeDasharray={
                                      node.data.children ? '0' : '2,2'
                                    }
                                  />

                                  {node.data.users
                                    .map((user: any, index: number) => {
                                      return (
                                        <UserInfoTab
                                          data={user}
                                          position={index + 1}
                                        />
                                      )
                                    })}

                                  {/*<foreignObject
                                    y={160}
                                    x={70}
                                    width="100"
                                    height="50"
                                    fontSize={14}
                                    fontFamily="Arial"
                                    style={{ pointerEvents: 'none' }}
                                    color="#52acc3"
                                  >
                                    Смотреть всех
                                  </foreignObject>*/}
                                </>
                              )}
                            </Group>
                          )
                        })}
                      </Group>
                    )}
                  </Tree>
                </Group>
              </g>
            </svg>
          </div>
        )}
      </Zoom>
      <SectionModal open={modalDepOpen} isCloseModal={closeModal} item={item}/>
      <EmployeeModal open={modalOpen} isCloseModal={closeModal} />
    </div>
  )
}
